import { render } from "./CardGroupsParticipants.vue?vue&type=template&id=fa6ec81a&scoped=true"
import script from "./CardGroupsParticipants.vue?vue&type=script&lang=js"
export * from "./CardGroupsParticipants.vue?vue&type=script&lang=js"

import "./CardGroupsParticipants.vue?vue&type=style&index=0&id=fa6ec81a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa6ec81a"]])

export default __exports__